
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/warranty",
      function () {
        return require("private-next-pages/shop/warranty/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/warranty"])
      });
    }
  